import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe-decorator';
import { Subscription } from 'rxjs';
import { ContactPerson } from 'src/app/customer/models/customer.model';
import { CustomerManagementService } from 'src/app/customer/services/customer.service';
import { Customer } from 'src/app/shared/models/customer.model';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
})
export class ContactFormComponent implements OnInit {
  @ViewChild('customerForm', { static: true }) customerForm: NgForm;
  @Input() usStates: any[] = [];
  @Input() countries: any[] = [];
  @Input() model: Customer;
  isUSA: boolean = true;
  isUSAContact: boolean = true;

  isContactSaving: boolean = false;
  contactPersons: ContactPerson[] = [];

  @AutoUnsubscribe()
  usaStates$: Subscription;
  @AutoUnsubscribe()
  saveCustomerContactWithAddress$: Subscription;
  @AutoUnsubscribe()
  getAllCountries$: Subscription;

  constructor(private apiService: CustomerManagementService) {}

  ngOnInit(): void {}

  save() {
    const contactPerson = new ContactPerson();

    for (let key in this.customerForm.value) {
      if (key === 'IsMainContact') {
        contactPerson[key] = !!this.customerForm.value[key];
        break;
      }
      contactPerson[key] = this.customerForm.value[key];
    }

    this.contactPersons.push(contactPerson);
    this.customerForm.resetForm();
  }

  removeContactPerson(contactNumberIndex) {
    this.contactPersons.splice(contactNumberIndex, 1);
  }

  countryChanged(event: any) {
    this.isUSA = event.target.value === '230' ? true : false;
  }
}
